import { call, getContext, put } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';

import { EBuyPackageStatus } from '../../reducers/types';
import { depositAmountWidget } from '../../services/billingAccounts/depositAmountWidget';
import { updateDepositAccountPaymentToken } from '../../actions/depositAccount';
import {
  TSetBuyPackageHeldPayment,
  setBuyPackageLoading,
  setBuyPackageStatus,
  setBuyPackageConfirmationToken,
} from '../../actions/buyPackage';
import { EPaymentInitSource } from '../../services/billingAccounts/depositAmountWidget/types';

export function* payPackage(action: TSetBuyPackageHeldPayment) {
  const { requestedAmount, transactionId } = action.payload;
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  try {
    const params = {
      httpApi,
      logger,
      amount: requestedAmount,
      transactionId,
      paymentInitSource: EPaymentInitSource.AddFormDeposit,
    };

    // отображаем состояние загрузки
    yield put(setBuyPackageLoading({ isLoading: true }));

    // Получаем токен на оплату
    const confirmationToken: string = yield call(depositAmountWidget, params);

    // открываем модальное окно оплаты
    yield put(setBuyPackageStatus({ status: EBuyPackageStatus.NotEnoughMoneyWithDeposit }));
    yield put(setBuyPackageConfirmationToken({ confirmationToken }));
    yield put(updateDepositAccountPaymentToken(confirmationToken));
  } catch (e) {
    throw new Error(e.toString());
  }
}
